import { ActionHistoryI } from "../../processes/models/ActionHistory/type";
import {
  categoryId,
  QualityType,
  resolutionListT,
} from "../../utils/constants";
import { dimTypeT } from "../../utils/functions/playcanvas/playerSettings";
import { initialAppState } from "./app/appReducer";
import {
  IObject,
  IObjectProcessData,
  IStudioStage,
  SelectedObjectData,
  ITemplate,
  ISearchData,
  IProduct,
} from "./ui/uiTypes";
import { initialUserState } from "./user/userReducer";
import { CameraPreset } from "../../hooks/useCameraPresets";
import { initialHistoryState } from "./history/historyTypes";

export type envOptoinsT = "Background" | "Floor" | "Wall";
export type initialUiStateT = {
  activeEnvironmentId: number;
  activeObjectId: string | null;
  selectedModel: boolean;
  selectedType: dimTypeT;
  activeTab: categoryId | undefined;
  selectedVariants: Record<envOptoinsT, any>;
  environments: IStudioStage[];
  environmentsStage: IStudioStage[];
  environmentActiveValues: { proxyName: string; proxyValue: string }[];
  currentEnvironment: any;
  currentTemplate: ITemplate | null;
  currentTemplatePresets: CameraPreset[];
  renderHash: string;
  objects: IObject[];
  currentCategoryFolder: IObject | null;
  selectObjects: SelectedObjectData;
  objectProcessData: IObjectProcessData;
  // Cache of fetched products by projectId to ensure options persist across reselection
  productsCache: Record<number, IProduct[]>;
  activeFolder: IObject | null;
  templateFolders: IObject[];
  templates: ITemplate[];
  isTemplatesLoading: boolean;
  templatesError: string | null;
  templatesCount: number;
  foldersCount: number;
  // history: IRenderRow[];
  dataHistory: ActionHistoryI | null;
  screenSettings: {
    aspectRatio: resolutionListT | null;
    quality: QualityType;
    wrapperDimensions: { w: number; h: number };
  };
  camera: any;
  organizationId: number;
  lod: number;
  searchData: ISearchData;
};

export type stateT = {
  ui: initialUiStateT;
  user: initialUserState;
  app: initialAppState;
  history: initialHistoryState;
};

export enum UI_ACTION_NAME {
  SET_SELECT_MODEL = "ui/setSelectedModel",
  SET_ACTIVE_ENV_INDEX = "ui/setActiveEnvironmentId",
  SET_ACTIVE_ENV_VARIANT_VALUE = "ui/setEnvironmentActiveValue",

  UNDO = "ui_custom/undo",
  REDO = "ui_custom/redo",
  ADD_HISTORY = "ui_custom/addHistory",
  SET_DATA_UI = "ui/setDataUI",
  SET_ACTIVE_ENV_VARIANT_VALUE_CUSTOM = "ui/setEnvironmentActiveValue_custom",

  INIT_SELECT_OBJECT_DATA = "ui/initSelectDataObject",
  SET_SELECT_OBJECT_DATA = "ui/setSelectObjectData",
  SET_ACTIVE_FOLDER = "ui/setActiveFolder",
  UPDATE_VALUE_OPTION_SELECT_OBJECT = "ui_custom/updateValueOptionSelectObject",
  FINISH_OBJECT_PROCESS = "ui_custom/finishObjectProcess",
  REMOVE_OBJECT = "ui_custom/removeObject",
  REMOVE_SELECT_OBJECT_DATA = "ui/removeSelectObjectData",
  REPLACE_OBJECT_DATA = "ui_custom/replaceObjectData",

  SET_SEARCH_VALUE = "ui_custom/setSearchValue",
}

export enum UI_THUNK_ACTION_NAME {
  GET_STAGES_FUL_FILLED = "ui/getStagesListThunk:fetch/fulfilled",
}
